import { render } from "./navTop.vue?vue&type=template&id=8c87a8dc&scoped=true"
const script = {}

import "./navTop.vue?vue&type=style&index=0&id=8c87a8dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c87a8dc"]])

export default __exports__